<app-header></app-header>
<div class="page-title-area page-title-style-two item-rights bg-auction">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Access Mass-Media in CMDTAMP</li>
            </ul>
            <h2>Access Mass-Media in CMDTAMP</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">

                <ul>
                    <li class="mass-list"> Accesul reprezentantilor mass – media in unitate, in vederea inregistrarii, fotografierii sau
                        filmarii se face in baza unei cereri scrise aprobata de catre Directorul General, respectand
                        dreptul la intimitate al pacientilor.
                    </li>
                    <li class="mass-list"> In situatia in care Directorul General nu este prezent in Centru, accesul reprezentantilor mass
                        – media este permis numai cu aprobarea inlocuitorului de drept, desemnat prin act de decizie
                        interna.
                    </li>
                    <li class="mass-list"> Acreditarea de presa se acorda fara discriminare, in cel mult doua zile de la inregistrarea
                        solicitarii sau dupa caz, in functie de situatie.
                    </li>
                    <li class="mass-list"> Reprezentantii mass-media vor fi insotiti permanent, pe parcursul vizitei, de catre Directorul
                        General sau de catre o persoana desemnata de catre conducere.
                    </li>
                    <li class="mass-list"> Filmarea in cadrul Centrului va fi permisa doar cu acordul conducerii si a persoanelor
                        implicate: medici, asistente, alt personal de specialitate.
                    </li>
                    <li class="mass-list"> In cazul in care reprezentantul acreditat participa la prezentarea unei proceduri medicale in
                        care este implicat si un pacient, se va informa pacientul si se va cere acordul in scris al
                        acestuia.
                    </li>
                    <li class="mass-list"> Daca reprezentantii mass-media solicita contactul cu un pacient sau angajat al Centrului,
                        acesta va fi informat in prealabil.
                    </li>
                    <li class="mass-list"> Pentru evenimente deosebite: accidente de munca, accidente rutiere, etc, reprezentantii
                        mass-media vor avea acces in unitate respectand prezenta procedura si sub rezerva codului
                        deontologic si tinand cont de Legea nr. 46/2003 – Legea drepturilor pacientului.
                    </li>
                    <li class="mass-list">Reprezentantii mass-media vor avea acces neingradit in cazul in care insotesc o delegatie
                        oficiala, cu acordul acesteia si insotita de Directorul General sau de o persoana desemnata de
                        aceasta.</li>

                </ul>








            </div>
        </div>
    </div>
</div>
